"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY = void 0;
var CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY;

(function (CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY) {
  CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY["CONTRACT_ID"] = "contract_id";
  CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY["FULFILLMENT_ID"] = "fulfillment_id";
  CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY["GROUP_ID"] = "group_id";
  CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY["LICENSE_ID"] = "license_id";
  CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY["ORDER_ID"] = "order_id";
  CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY["ORGANIZATION_ID"] = "organization_id";
})(CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY = exports.CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY || (exports.CONSUMABLE_SUMMARIZATION_SUMMARIZE_BY = {}));